import { render, staticRenderFns } from "./ProviderShowTables.vue?vue&type=template&id=72317b4b"
import script from "./ProviderShowTables.vue?vue&type=script&lang=js"
export * from "./ProviderShowTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports